import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { ANALYTICS_EVENTS, trackClientEvent } from '@/_shared/lib/analytics';
import { routePatternOf, routeSectionOf } from '@/_shared/lib/route-pattern';

/** One `pageViewed` per SPA route change. The pattern is sent, never the resolved path. */
export function AnalyticsPageView(): null {
  const { pathname } = useLocation();

  useEffect(() => {
    trackClientEvent(ANALYTICS_EVENTS.pageViewed, {
      route: routePatternOf(pathname),
      section: routeSectionOf(pathname),
    });
  }, [pathname]);

  return null;
}
